(function(){
  document.addEventListener('DOMContentLoaded',function(){
    var offers=Array.prototype.slice.call(document.querySelectorAll('[data-rive-product-gift-offer]'));
    if(!offers.length)return;
    var claimType=new URL(window.location.href).searchParams.get('rive_gift')||'';
    var root=document.querySelector('[data-rive-product]');
    var info=root&&root.querySelector('.ln-product__info');
    if(!root||!info)return;
    var priceAnchor=info.querySelector('.ln-price');
    var title=info.querySelector('h1');
    var visibleOffers=offers.filter(function(offer){
      if(offer.dataset.giftProduct==='true')return true;
      return offer.dataset.mensProduct!=='true'&&offer.dataset.giftType==='clutch';
    });
    if(!visibleOffers.length)return;
    visibleOffers.forEach(function(offer){
      var standardPlacement=offer.dataset.giftProduct!=='true';
      var insertionAnchor=standardPlacement?(priceAnchor||title):(title||priceAnchor);
      if(insertionAnchor)insertionAnchor.after(offer);
      offer.classList.add('is-mounted');
    });
    var activeOffer=visibleOffers.find(function(offer){
      return offer.dataset.giftProduct==='true'&&offer.dataset.eligible==='true'&&offer.dataset.giftType===claimType;
    });
    var form=root.querySelector('[data-rive-product-form]');
    if(!activeOffer||!form)return;
    var giftType=activeOffer.dataset.giftType;
    root.classList.add('is-rive-gift-product-eligible');
    var price=root.querySelector('.ln-price');
    if(price){
      price.textContent='';
      var old=document.createElement('s');
      old.textContent=activeOffer.dataset.originalPrice;
      var free=document.createElement('strong');
      free.textContent='0,00 €';
      var label=document.createElement('em');
      label.textContent='REGALO';
      price.append(old,free,label);
    }
    var propertyName=giftType==='earrings'?'properties[_rive_free_gift]':'properties[_rive_free_clutch]';
    if(!form.querySelector('[name="'+propertyName+'"]')){
      var property=document.createElement('input');
      property.type='hidden';
      property.name=propertyName;
      property.value='true';
      form.append(property);
    }
    var add=form.querySelector('.ln-add');
    if(add)add.textContent=giftType==='earrings'?'Añadir pendientes gratis':'Añadir bolso gratis';
    var keys=(activeOffer.dataset.existingKeys||'').split('|').filter(Boolean);
    if(keys.length){
      form.addEventListener('submit',function handler(event){
        if(form.dataset.riveGiftCleared==='true')return;
        event.preventDefault();
        event.stopImmediatePropagation();
        var updates={};
        keys.forEach(function(key){updates[key]=0});
        fetch('/cart/update.js',{
          method:'POST',
          headers:{'Content-Type':'application/json','Accept':'application/json'},
          body:JSON.stringify({updates:updates})
        }).then(function(response){
          if(!response.ok)throw new Error('No se pudo cambiar el color del regalo');
          form.dataset.riveGiftCleared='true';
          form.requestSubmit();
        }).catch(function(){
          form.dataset.riveGiftCleared='true';
          form.requestSubmit();
        });
      },true);
    }
  });
})();